export default "__VITE_ASSET__KxNkUvCU__"